__turbopack_context__.v({
  "appSearch": "AddConnectionModal-module__cJcwpq__appSearch",
  "connectionSummary": "AddConnectionModal-module__cJcwpq__connectionSummary",
  "emptyState": "AddConnectionModal-module__cJcwpq__emptyState",
  "managedAppList": "AddConnectionModal-module__cJcwpq__managedAppList",
  "managedAppListLoading": "AddConnectionModal-module__cJcwpq__managedAppListLoading",
  "managedAppListLoadingItem": "AddConnectionModal-module__cJcwpq__managedAppListLoadingItem",
  "managedAppRow": "AddConnectionModal-module__cJcwpq__managedAppRow",
  "managedAppRowContent": "AddConnectionModal-module__cJcwpq__managedAppRowContent",
  "managedAppRowRestricted": "AddConnectionModal-module__cJcwpq__managedAppRowRestricted",
  "managedAppRowRestrictedApp": "AddConnectionModal-module__cJcwpq__managedAppRowRestrictedApp",
  "managedAppRowRestrictedInfo": "AddConnectionModal-module__cJcwpq__managedAppRowRestrictedInfo",
  "managedAppRowSpinner": "AddConnectionModal-module__cJcwpq__managedAppRowSpinner",
  "managedBadgeIcon": "AddConnectionModal-module__cJcwpq__managedBadgeIcon",
  "modalBody": "AddConnectionModal-module__cJcwpq__modalBody",
  "modalDialog": "AddConnectionModal-module__cJcwpq__modalDialog",
  "shareList": "AddConnectionModal-module__cJcwpq__shareList",
  "shareSection": "AddConnectionModal-module__cJcwpq__shareSection",
});
